import { IPage } from '@types'
import Layout from 'components/layouts/Layout'

import dynamic from 'next/dynamic'

let MaxReturnView = dynamic(() => import('components/auth/MaxReturnView'), {
  ssr: false,
})

// Приёмник подтверждения входа через MAX: бот редиректит сюда с грантом.
// Сама логика — в MaxReturnView (клиент: логинит браузер, где открылась
// ссылка, и уходит на исходную страницу).
let MaxReturnPage: IPage = () => <MaxReturnView />

MaxReturnPage.getLayout = (page) => (
  <Layout title={page.props.title}>{page}</Layout>
)

export const getStaticProps = () => ({
  props: {
    title: 'Вход через MAX',
  },
})

export default MaxReturnPage
